import axios from "axios";

// Same-origin: the app host always serves /api (avoids a mis-injected build-time origin).
export const BACKEND_URL = window.location.origin;

const apiClient = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("kraus_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("kraus_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const API_BASE = `${BACKEND_URL}/api`;
export default apiClient;
